export const ASSET_DEFAULT_ICON_TEST = /icons\/(.*)\.png/;

export const isDefaultIcon = (previewUrl?: string) =>
	previewUrl?.match(ASSET_DEFAULT_ICON_TEST);

export default isDefaultIcon;
